var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 17.5464C35.5 27.237 27.6443 35.0923 17.9535 35.0923C8.26271 35.0923 0.407471 27.237 0.407471 17.5464C0.407471 7.85583 8.26275 0 17.9535 0C27.6443 0 35.5 7.85526 35.5 17.5464Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6879 7.48253C25.8262 2.02658 20.5306 5.89522 21.4579 9.97294C22.19 13.1768 25.7062 17.7231 25.7062 17.7231C26.213 17.5449 31.1126 15.7771 33.4498 13.466C36.4228 10.5258 34.0346 4.41823 28.6879 7.48253Z",
    fill: "#CC342F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21857 7.48253C10.0815 2.02658 15.3767 5.89522 14.4483 9.97294C13.7178 13.1768 10.2007 17.7231 10.2007 17.7231C9.69395 17.5449 4.7943 15.7771 2.45751 13.466C-0.515527 10.5258 1.87274 4.41823 7.21857 7.48253Z",
    fill: "#CC342F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.547 21.0716C11.1079 20.9263 10.6953 21.402 10.8228 21.9102C11.577 24.9066 14.4796 27.1402 17.9535 27.1402C21.4274 27.1402 24.3307 24.9066 25.0842 21.9102C25.2121 21.402 24.7991 20.9263 24.36 21.0716C22.4338 21.7104 20.2578 22.0703 17.9535 22.0703C15.6492 22.0703 13.474 21.7104 11.547 21.0716Z",
    fill: "#562912"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9536 24.0931C16.4257 24.0931 15.112 25.0228 14.5339 26.3529C15.555 26.8532 16.7175 27.1402 17.9536 27.1402C19.1909 27.1402 20.3529 26.8532 21.3728 26.3529C20.7948 25.0228 19.4827 24.0931 17.9536 24.0931Z",
    fill: "#CC342F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji5);
export default __webpack_public_path__ + "static/media/Emoji5.6121fed7d00a024d1c13206dd3fa6994.svg";
export { ForwardRef as ReactComponent };